/**
 * Leaving the chat screen (dashboard, settings, comments …) closes the open chat. Otherwise it stays "open" off screen:
 * a new customer message there is marked read (unread gone for the whole team, the web visitor sees "อ่านแล้ว") and
 * colleagues keep seeing "… กำลังดูแชทนี้". Coming back opens what the address says ('/' none, '/c/:id' that chat).
 */
import type { Router } from 'vue-router'
import { useInbox } from '../stores/inbox'

/** Route names that show the chat inbox (router.ts). */
export const INBOX_ROUTES: ReadonlySet<string> = new Set(['inbox', 'conversation'])

export function installLeaveInbox(router: Router): void {
  router.afterEach((to, _from, failure) => {
    if (failure || INBOX_ROUTES.has(String(to.name ?? ''))) return
    try {
      const inbox = useInbox()
      if (inbox.selectedId) void inbox.select(null)
    } catch {
      /* no store yet (tests without Pinia) */
    }
  })
}
